import { Nav } from "../../components/Nav";

export default function Header() {
	return (
		<header data-testid="header">
			<Nav />
		</header>
	);
}
